document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.cye-widget').forEach(initExperienceWidget);
});

function initExperienceWidget(widget) {
  const modeInputs = widget.querySelectorAll('input[name^="cye-mode-"]');
  const modeOptions = widget.querySelectorAll('.cye-mode-option');
  const curatedPanel = widget.querySelector('.cye-curated-panel');
  const selectPanel = widget.querySelector('.cye-select-panel');
  const slots = Array.from(widget.querySelectorAll('.cye-slot'));
  const warningEl = widget.querySelector('.cye-warning');
  const propMode = widget.querySelector('.cye-prop-mode');
  const propSlots = Array.from(widget.querySelectorAll('.cye-prop-slot'));

  const formId = widget.dataset.formId;
  let form = formId ? document.getElementById(formId) : null;
  if (!form) {
    form = document.querySelector('form[data-type="add-to-cart-form"]');
  }
  const addToCartBtn = form ? form.querySelector('[type="submit"], [name="add"]') : null;

  const lockedRoaster = widget.dataset.lockedRoaster || '';
  const lockedAtPackSize = parseInt(widget.dataset.lockedAtPackSize, 10) || null;

  let mode = 'curated';
  let packSize = getPackSizeFromVariant();

  function isLockActive() {
    return Boolean(lockedRoaster) && lockedAtPackSize !== null && packSize === lockedAtPackSize;
  }

  function getPackSizeFromVariant() {
    const allChecked = document.querySelectorAll('input[type="radio"]:checked, select option:checked');
    let found = null;
    allChecked.forEach(function (el) {
      if (widget.contains(el)) return;
      const belongsToForm = form && (el.form === form || el.getAttribute('form') === form.id);
      if (form && !belongsToForm) return;
      const text = el.value || el.textContent || '';
      const match = text.match(/(\d+)\s*Pack/i);
      if (match) found = parseInt(match[1], 10);
    });
    if (!found && form) {
      const text = form.textContent || '';
      const match = text.match(/(\d+)\s*Pack/i);
      if (match) found = parseInt(match[1], 10);
    }
    return found || 1;
  }

  function showSlotsForPackSize() {
    const lockActive = isLockActive();
    slots.forEach(function (slot) {
      const slotNum = parseInt(slot.dataset.slot, 10);
      slot.style.display = slotNum <= packSize ? 'block' : 'none';

      const lockedDisplay = slot.querySelector('.cye-slot-locked');
      const select = slot.querySelector('.cye-slot-select');
      const lockedNameEl = slot.querySelector('.cye-locked-name');

      if (slotNum > packSize) {
        select.value = '';
        return;
      }

      if (lockActive && slotNum === 1) {
        lockedDisplay.style.display = 'flex';
        select.style.display = 'none';
        lockedNameEl.textContent = lockedRoaster;
      } else {
        lockedDisplay.style.display = 'none';
        select.style.display = 'block';
      }
    });
  }

  function getActiveSlots() {
    return slots.filter(function (slot) {
      return parseInt(slot.dataset.slot, 10) <= packSize;
    });
  }

  function refreshDropdownOptions() {
    const lockActive = isLockActive();
    const activeSlots = getActiveSlots();
    const chosenValues = activeSlots
      .map(function (slot) { return slot.querySelector('.cye-slot-select').value; })
      .filter(Boolean);

    if (lockActive) chosenValues.push(lockedRoaster);

    activeSlots.forEach(function (slot) {
      const slotNum = parseInt(slot.dataset.slot, 10);
      if (lockActive && slotNum === 1) return;

      const select = slot.querySelector('.cye-slot-select');
      const currentValue = select.value;
      Array.from(select.options).forEach(function (opt) {
        if (!opt.value) return;
        const chosenElsewhere = chosenValues.includes(opt.value) && opt.value !== currentValue;
        opt.disabled = chosenElsewhere;
      });
    });
  }

  function isValidSelection() {
    if (mode === 'curated') return true;
    const lockActive = isLockActive();
    const activeSlots = getActiveSlots();
    return activeSlots.every(function (slot) {
      const slotNum = parseInt(slot.dataset.slot, 10);
      if (lockActive && slotNum === 1) return true;
      return slot.querySelector('.cye-slot-select').value !== '';
    });
  }

  function updateHiddenProps() {
    propMode.value = mode === 'curated' ? 'Curated Selection' : 'Select My Coffees';
    const lockActive = isLockActive();
    propSlots.forEach(function (input) {
      const slotNum = parseInt(input.dataset.slot, 10);
      if (mode === 'curated') {
        input.value = slotNum <= packSize ? 'Surprise Me' : '';
        return;
      }
      if (slotNum > packSize) {
        input.value = '';
        return;
      }
      if (lockActive && slotNum === 1) {
        input.value = lockedRoaster;
        return;
      }
      const slot = slots.find(function (s) { return parseInt(s.dataset.slot, 10) === slotNum; });
      const select = slot ? slot.querySelector('.cye-slot-select') : null;
      input.value = select ? select.value : '';
    });
  }

  function updateAddToCartState() {
    const valid = isValidSelection();
    warningEl.style.display = valid ? 'none' : 'block';
    if (addToCartBtn) addToCartBtn.disabled = !valid;
  }

  function refreshAll() {
    packSize = getPackSizeFromVariant();
    showSlotsForPackSize();
    refreshDropdownOptions();
    updateHiddenProps();
    updateAddToCartState();
  }

  modeInputs.forEach(function (input) {
    input.addEventListener('change', function () {
      mode = input.value;
      modeOptions.forEach(function (opt) {
        opt.classList.toggle('cye-mode-active', opt.contains(input) ? input.checked : opt.querySelector('input').checked);
      });
      curatedPanel.style.display = mode === 'curated' ? 'block' : 'none';
      selectPanel.style.display = mode === 'select' ? 'block' : 'none';
      refreshAll();
    });
  });

  slots.forEach(function (slot) {
    const select = slot.querySelector('.cye-slot-select');
    select.addEventListener('change', function () {
      refreshDropdownOptions();
      updateHiddenProps();
      updateAddToCartState();
    });
  });

  document.addEventListener('change', function (e) {
    if (!e.target.matches('input[type="radio"], select')) return;
    if (widget.contains(e.target)) return;
    const belongsToForm = form && (e.target.form === form || e.target.getAttribute('form') === form.id);
    if (form && !belongsToForm) return;
    refreshAll();
  });

  refreshAll();
}